import {
  registerComponent,
  publishEventOnNextPage,
  pushDataLayer,
} from "helpers";

registerComponent(
  "store-locator-trigger",
  class StoreLocatorTrigger extends HTMLElement {
    connectedCallback() {
      this.addEventListener("click", (event) => {
        pushDataLayer({ event: "store_locator_open" });
        // A trigger can wrap more than the locations link (the footer help bar
        // also holds the phone number), and only that link navigates, so only
        // a click on it queues the event for the next page. Matching any
        // non-phone link keeps this working if the locations URL changes.
        if (event.target.closest('a:not([href^="tel:"])')) {
          publishEventOnNextPage("store_locator_open");
        }
      });
    }
  },
);
